import { useMemo, useRef } from 'react';

import { useNonFavouritedSportsBooks } from './useNonFavouritedSportsBooks';

export const useNonFavouritedSportsBookIds = () => {
  const nonFavouritedSportsBooks = useNonFavouritedSportsBooks();
  const previousResultRef = useRef<string[]>([]);
  const previousKeyRef = useRef<string>('');

  return useMemo(() => {
    const currentIds = nonFavouritedSportsBooks.map(bookmaker => bookmaker.code);
    const currentKey = currentIds.join(',');

    if (currentKey === previousKeyRef.current) {
      return previousResultRef.current;
    }

    previousResultRef.current = currentIds;
    previousKeyRef.current = currentKey;
    return currentIds;
  }, [nonFavouritedSportsBooks]);
};
